<!-- 恢复 -->
<template>
    <div class="import-tool">
        <Modal
            v-model="visible"
            title="恢复"
            :mask-closable="false"
            width="420"
            :footer-hide="true"
            class="my-modal top import-tool-modal2"
        >
            <Form v-if="visible" ref="form" :model="from" class="page-form less" :label-width="90">
                <FormItem prop="name" label="客户姓名" :rules="$units.formRule.required('请输入')" class="full">
                    <Input v-model="from.name" disabled placeholder="请输入" />
                </FormItem>

                <FormItem label="业务员归属" class="full">
                    <RadioGroup v-model="from.type" @on-change="changeType">
                        <Radio label="1">原业务员</Radio>
                        <Radio label="2">重新分配</Radio>
                    </RadioGroup>
                </FormItem>

                <FormItem prop="agentId" label="所属业务员" :rules="$units.formRule.required('请选择')" class="full" v-if="from.type == 2">
                    <Select v-model="from.agentId" clearable filterable transfer>
                        <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
            </Form>

            <div class="footer-btn">
                <div class="cancel" @click="visible = false">取消</div>
                <div class="confirm" @click="ok">确认</div>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    props: ['getInsureList'],
    data() {
        return {
            visible: false,
            agentList: [],
            from: {},
            oldAgentId: null,
            agentId:""
        };
    },
    methods: {
        open(data) {
            this.$refs.form && this.$refs.form.resetFields();
            this.from = JSON.parse(JSON.stringify(data));
            this.agentId = data.agentId;
            this.from.type = '1';
            this.visible = true;
        },

        changeType(value) {
            if (value == 2) {
                this.from.agentId = '';
                this.$http({
                    url: `/buz/userBase/queryUserByOrgId?orgId=${this.from.organizationId}`,
                    type: 'GET'
                }).then(res => {
                    this.agentList = res.data.filter(item => item.id != this.agentId);
                });
            }
        },

        ok() {
            this.$refs.form.validate().then(valid => {
                if (!valid) {
                    return;
                }
                this.submit();
            });
        },

        submit() {
            let data = {};
            if (this.from.type == 1) {
                data = {
                    id: this.from.id
                };
            } else {
                data = {
                    id: this.from.id,
                    agentId: this.from.agentId
                };
            }
            this.$http({
                url: `/buz/customerBase/restore`,
                type: 'POST',
                data
            }).then(res => {
                this.visible = false;
                this.getInsureList();
                this.$notice.success('恢复成功');
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.import-tool-modal2 /deep/ {
    .myFormStyle {
        padding-left: 0px;
    }

    .ivu-modal-body {
        padding-bottom: 40px;
    }
    .ivu-modal-header-inner {
        font-size: 14px;
        font-weight: bold;
        color: #3c464f;
    }
    .ivu-modal-close {
        top: 4px;
        .ivu-icon-ios-close {
            font-size: 30px;
            color: #a8adb7;
        }
    }
    .ivu-modal-header {
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
    }
    .footer-btn {
        margin: 0 auto;
        display: flex;
        width: 250px;
        .confirm {
            margin: 0 auto;
            width: 100px;
            height: 30px;
            background-color: #236dff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #fff;
        }
        .confirm:hover {
            cursor: pointer;
        }
        .cancel {
            margin: 0 auto;
            width: 100px;
            height: 30px;
            border: 1px solid #236dff;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #236dff;
        }
        .cancel:hover {
            cursor: pointer;
        }
    }
}

/deep/ .ivu-form-item-label {
    font-size: 12px !important;
}
/deep/ .treeNode {
    font-size: 12px !important;
}
/deep/ .ivu-select-placeholder {
    font-size: 12px !important;
}
</style>
